<template>
  <!--  <ion-page>-->
  <div class="app-window">

  <ion-header>
    <ion-toolbar>
      <ion-title>Evaluation L2: Your Details</ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content>
    <ion-list>

      <ion-item v-for="qi in quizItems" v-bind:key="qi.code">
        <template v-if="qi.type === 'year'">
          year
        </template>
        <template v-else-if="qi.type === 'multi-select-card'">
          multi-select-card
        </template>
        <template v-else-if="qi.type === 'select-row'">
          select-row
        </template>
        <template v-else-if="qi.type === 'engcert'">
          <quiz-item-english-certification :quiz-item="qi" v-on:answer="qi._answer = $event"></quiz-item-english-certification>
        </template>
        <template v-else>
          <quiz-item-grade-select :quiz-item="qi" v-on:answer="qi._answer = $event"></quiz-item-grade-select>
        </template>
        <!--        <app-select-year *ngSwitchCase="'year'" [quizItem]="qi" (onChange)="dataChanged()"></app-select-year>-->
        <!--        <app-multi-select *ngSwitchCase="'multi-select-card'" [quizItem]="qi" (onChange)="dataChanged()"></app-multi-select>-->
        <!--        <app-select-card *ngSwitchCase="'select-row'" [quizItem]="qi" (onChange)="dataChanged()"></app-select-card>-->
        <!--        <app-eng-certification *ngSwitchCase="'engcert'" [quizItem]="qi" (onChange)="dataChanged()"></app-eng-certification>-->
        <!--        <app-select-grade *ngSwitchDefault [quizItem]="qi" (onChange)="dataChanged()"></app-select-grade>-->

      </ion-item>
    </ion-list>
  </ion-content>

  <ion-footer>
    <ion-toolbar>
      <ion-button slot="start"  :fill="'outline'" :href="'/account/'">
        <ion-icon :icon="chevronBackOutline"></ion-icon> Back
      </ion-button>
      <ion-button slot="end" v-on:click="proceed()">
        Next <ion-icon :icon="chevronForwardOutline"></ion-icon>
      </ion-button>
    </ion-toolbar>
  </ion-footer>
  </div>
</template>

<script>
import {
  IonHeader,
  IonToolbar,
  IonTitle,
  IonFooter,
  IonButton,
  IonIcon,
  IonItem,
  // IonLabel,
  IonList,
  IonContent,
} from '@ionic/vue';
import {
  chevronForwardOutline,
  chevronBackOutline
} from 'ionicons/icons';

import eoppService from "@/mixins/EoppService";
import QuizItemGradeSelect from "@/enrol/QuizItemGradeSelect";
import QuizItemEnglishCertification from "@/enrol/QuizItemEnglishCertification";
// import QuizItemSelect from './QuizItemSelect.vue';
import router from "./Router";

export default {
  name: 'QuizL2',
  components: {
    QuizItemEnglishCertification,
    QuizItemGradeSelect,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonFooter,
    IonButton,
    IonIcon,
    IonItem,
    // IonLabel,
    IonList,
    IonContent,
    // QuizItemSelect
  },
  mixins: [eoppService],
  data() {
    return {
      chevronForwardOutline,
      chevronBackOutline,
      quizItems:[],
      mirror: true
    };
  },
  mounted() {
    if ( this.lead) {
      this.loadQuiz();
    } else {
      this.getAccountLead().then(res => {
        console.log(res.data);
        this.$store.commit('leadInfo', res.data);
        this.loadQuiz();
      })
    }
  },
  methods: {
    back: function () {
      router.push({ path: '/' })
    },
    proceed: function () {
      console.log(this.quizItems);
      // router.push({ path: '/quiz' })
    },

    loadQuiz: function () {

      let l2Req = {
        email : this.lead.email,
        programCode : this.lead.cf.pref_program
      }

      this.postData('/data/quiz?type=l2', l2Req).then( res => {
        console.log(res)
        if (res.data && res.data.length > 0 ) {
          res.data.sort((a, b) => a.order - b.order);
          let idx = 1;
          res.data.forEach(o => o.order = idx++);
          this.quizItems = res.data;
        } else {
        //   //no l2 move to contact details
        //   this.navCtrl.navigateForward('/quiz/contact-details');
        }
      });
    }
  }
}
</script>
<style>

</style>
